import React from "react";

import { GridColumn, GridRow } from "src/common/components/Grid";
import {
	FieldSkeleton,
	FormControlLabelSkeleton,
	LabelSkeleton,
	RadioSkeleton,
	SelectSkeleton
} from "src/common/components/Skeletons";

export const FieldsetSkeleton: React.FunctionComponent = () => (
	<>
		<GridRow>
			<GridColumn columnSize={6}>
				<FieldSkeleton>
					<LabelSkeleton />
					<SelectSkeleton />
				</FieldSkeleton>
			</GridColumn>
			<GridColumn columnSize={6}>
				<FieldSkeleton>
					<LabelSkeleton />
					<FormControlLabelSkeleton control={<RadioSkeleton />} />
				</FieldSkeleton>
			</GridColumn>
		</GridRow>
	</>
);
